/*
 * eclipse-pdp.js
 *
 * Buy-box behavior for the Total Solar Eclipse PDP:
 * - tier radio selection (reveals rows gate by data-min-tier, total updates,
 *   year tier reveals the person fields)
 * - Eclipse Spell add-on toggle (reveals the wish field, joins the cart call)
 * - THE ASK writes to the ORDER NOTE via /cart/update.js, never attributes:
 *   main answer as the centre, person fields and wish appended as labeled
 *   lines. All skippable: an empty note trips the fulfilment safeguard hold
 *   and details are chased by email.
 * - two-step add to cart: /cart/add.js (items[]) then /cart/update.js (note)
 * - live countdown to the real eclipse datetime (display-only, hides when past)
 * - sticky mobile ATC once the buy box scrolls away
 */

(function () {
  const root = document.querySelector('[data-ec-root]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.prototype.slice.call(root.querySelectorAll(s));
  const JSON_HEADERS = { 'Content-Type': 'application/json' };

  const cartUrl = root.dataset.cartUrl || '/cart';
  const cartAddUrl = (root.dataset.cartAddUrl || '/cart/add') + '.js';
  const cartUpdateUrl = (root.dataset.cartUpdateUrl || '/cart/update') + '.js';
  const moneyPrefix = root.dataset.moneyPrefix || '£';
  const spellVariant = root.dataset.spellVariant || '';
  const spellCents = parseInt(root.dataset.spellCents || '0', 10) || 0;

  function analytics(event, payload) {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...(payload || {}) });
  }
  function money(cents) {
    const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyPrefix + v;
  }

  // --- tier selection ---------------------------------------------------------
  const tiers = $$('[data-ec-tier]');
  const spellBtn = $('[data-ec-spell]');
  const personWrap = $('[data-ask-person]');
  const wishWrap = $('[data-ask-wish-wrap]');
  let selectedTier = parseInt(root.dataset.defaultTier || '2', 10) || 2;

  function currentTierEl() {
    return tiers.find((t) => parseInt(t.dataset.ecTier, 10) === selectedTier) || tiers[0];
  }
  function spellOn() {
    return !!(spellBtn && spellBtn.getAttribute('aria-pressed') === 'true');
  }
  function totalCents() {
    const t = currentTierEl();
    let total = t ? parseInt(t.dataset.priceCents || '0', 10) : 0;
    if (spellOn()) total += spellCents;
    return total;
  }
  function renderTotal() {
    const label = money(totalCents());
    const a = $('[data-ec-atc-price]');
    const b = $('[data-ec-atc-price-sticky]');
    if (a) a.textContent = '· ' + label;
    if (b) b.textContent = '· ' + label;
  }
  function applyTier() {
    tiers.forEach((t) => {
      const on = parseInt(t.dataset.ecTier, 10) === selectedTier;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    // Selected tier shows only what it includes: its rollup line (for tiers
    // 2/3) plus its own rows. Lower tiers fold into the rollup wording.
    $$('[data-ec-reveal]').forEach((r) => {
      r.hidden = (parseInt(r.dataset.tier || '1', 10) || 1) !== selectedTier;
    });
    $$('[data-ec-rollup]').forEach((r) => {
      r.hidden = (parseInt(r.dataset.ecRollup, 10) || 0) !== selectedTier;
    });
    if (personWrap) personWrap.hidden = selectedTier !== 3;
    renderTotal();
  }
  tiers.forEach((t) => t.addEventListener('click', () => {
    selectedTier = parseInt(t.dataset.ecTier, 10) || 1;
    applyTier();
    analytics('eclipse_tier_selected', { tier: selectedTier });
  }));

  // --- spell add-on -----------------------------------------------------------
  if (spellBtn) {
    spellBtn.addEventListener('click', () => {
      const on = !spellOn();
      spellBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (wishWrap) wishWrap.hidden = !on;
      renderTotal();
      analytics('eclipse_spell_toggled', { on });
    });
  }

  // --- the ask -> order note --------------------------------------------------
  // Main answer is the centre of the reading; person fields and the wish are
  // APPENDED to the note as labeled lines (never separate cart attributes, or
  // fulfilment's person section silently degrades). Empty everything -> empty
  // note -> the fulfilment safeguard holds and asks by email.
  function buildNote() {
    const lines = [];
    const main = $('[data-ask-main]');
    if (main && main.value.trim()) lines.push('What I most want right now: ' + main.value.trim());
    if (selectedTier === 3) {
      const name = $('[data-ask-name]');
      const rel = $('[data-ask-relation]');
      if (name && name.value.trim()) lines.push('Their first name: ' + name.value.trim());
      if (rel && rel.value.trim()) lines.push('Who they are to me: ' + rel.value.trim());
    }
    if (spellOn()) {
      const wish = $('[data-ask-wish]');
      if (wish && wish.value.trim()) lines.push('The wish: ' + wish.value.trim());
    }
    return lines.join('\n');
  }

  // --- add to cart ------------------------------------------------------------
  async function addToCart(btn) {
    const tierEl = currentTierEl();
    const variantId = tierEl && tierEl.dataset.variantId;
    const errEl = $('[data-add-error]');
    if (!variantId) {
      if (errEl) { errEl.textContent = 'This reading is not available right now. Please try another option.'; errEl.hidden = false; }
      return;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errEl) errEl.hidden = true;
    const items = [{ id: parseInt(variantId, 10), quantity: 1 }];
    if (spellOn() && spellVariant) items.push({ id: parseInt(spellVariant, 10), quantity: 1 });
    analytics('eclipse_atc', { tier: selectedTier, spell: items.length > 1 });
    try {
      await fetch(cartAddUrl, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items }) });
      await fetch(cartUpdateUrl, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ note: buildNote() }) });
      window.location.href = cartUrl;
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (errEl) { errEl.textContent = 'Something went wrong. Please try again.'; errEl.hidden = false; }
    }
  }
  const atcBtn = $('[data-add-to-cart]');
  const atcSticky = $('[data-add-to-cart-sticky]');
  if (atcBtn) atcBtn.addEventListener('click', () => addToCart(atcBtn));
  if (atcSticky) atcSticky.addEventListener('click', () => addToCart(atcSticky));

  // --- eclipse countdown ------------------------------------------------------
  const cdWrap = $('[data-ec-countdown-wrap]');
  const cdOut = $('[data-ec-countdown]');
  const targetIso = root.dataset.eclipseIso || '';
  if (cdWrap && cdOut && targetIso) {
    const target = Date.parse(targetIso);
    if (!Number.isNaN(target)) {
      function tick() {
        const left = target - Date.now();
        if (left <= 0) { cdWrap.hidden = true; return; }
        const d = Math.floor(left / 86400000);
        const h = Math.floor((left % 86400000) / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        const s = Math.floor((left % 60000) / 1000);
        cdOut.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
        cdWrap.hidden = false;
        setTimeout(tick, 1000);
      }
      tick();
    }
  }

  // --- sticky mobile ATC ------------------------------------------------------
  const sticky = $('[data-ec-sticky]');
  const buybox = $('[data-ec-buybox]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach((en) => { sticky.hidden = en.isIntersecting; });
    }, { threshold: 0.05 }).observe(buybox);
  }

  applyTier();
  analytics('eclipse_viewed', {});
})();
